module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-app__cal__nav"
  }, [_c('div', {
    staticClass: "d-app__cal__nav__btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('prev')
      }
    }
  }, [_c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M15.75 19.5L8.25 12l7.5-7.5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-app__cal__nav__btn d-app__cal__nav__btn__center",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('today')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('repitition.today')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "d-app__cal__nav__btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('next')
      }
    }
  }, [_c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M8.25 4.5l7.5 7.5-7.5 7.5"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47a823ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DApp/DAppCalendarNav.vue
// module id = 1895
// module chunks = 1